import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Cabeçalho de view.
 *
 * O `eyebrow` em azul, caixa alta e PT Sans Narrow é o marcador de seção do
 * sustenta-ai-app: diz em que parte do produto o usuário está sem competir com
 * o `<h1>`. Ele só aparece quando classifica de verdade — não é enfeite.
 *
 * A `acao` é o lugar da ÚNICA ação primária da tela (Hard rule 1): se uma tela
 * precisar de duas, uma delas não era primária.
 */
export function PageHeader({
  eyebrow,
  titulo,
  descricao,
  acao,
  className,
}: {
  eyebrow?: string;
  titulo: string;
  descricao: string;
  acao?: React.ReactNode;
  className?: string;
}) {
  return (
    <header className={cn('flex flex-wrap items-end justify-between gap-x-6 gap-y-4', className)}>
      <div className="flex min-w-0 flex-col gap-1.5">
        {eyebrow ? <p className="font-narrow text-micro uppercase tracking-[0.06em] text-primary">{eyebrow}</p> : null}
        <h1 className="text-page-title">{titulo}</h1>
        <p className="max-w-[68ch] text-lede text-on-surface-muted">{descricao}</p>
      </div>
      {acao ? <div className="flex shrink-0 items-center gap-2">{acao}</div> : null}
    </header>
  );
}

/** Contêiner da view: centraliza em 1200px; `largo` libera para tabela ampla. */
export function PageBody({
  children,
  largo = false,
  className,
}: {
  children: React.ReactNode;
  largo?: boolean;
  className?: string;
}) {
  return <div className={cn('cmp-page', largo && 'cmp-page--wide', 'flex flex-col gap-7', className)}>{children}</div>;
}

/** Cabeçalho de bloco dentro da view (acima de uma tabela ou de um grupo). */
export function SectionHeader({
  titulo,
  contagem,
  acao,
  className,
}: {
  titulo: string;
  contagem?: string;
  acao?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-wrap items-center gap-x-3 gap-y-2', className)}>
      <h2 className="text-section-title">{titulo}</h2>
      {contagem ? <span className="cmp-eyebrow">{contagem}</span> : null}
      {acao ? <div className="ml-auto flex items-center gap-2">{acao}</div> : null}
    </div>
  );
}
